import { CONFIRM_CASH_PAYMENT, FETCH_CASH_PAYMENTS, FETCH_DIRECT_PAYMENT_PAIN_FILES } from "@/store/action-types"
import { cachedActionWrapper } from "@/modules/common/store/tools"
import { CACHE_CASH_PAYMENTS, CACHE_DIRECT_PAYMENT_PAIN_FILES } from "@/store/cache-types"
import {
  ADD_CASH_PAYMENT, EDIT_CASH_PAYMENT,
  SET_CASH_PAYMENTS,
  SET_DIRECT_PAYMENT_PAIN_FILES,
  UPDATE_CASH_PAYMENT_STATE
} from "@/store/mutation-types"
import {
  DEC_LOADING,
  INC_LOADING,
  SET_ERROR_MESSAGE,
  SET_SNACKBAR_MESSAGE
} from "@/modules/common/store/mutation-types"
import Vue from "vue"

export default {
  namespaced: true,
  state: {
    directPaymentPainFiles: null,
    cashPayments: {}
  },
  getters: {
    directPaymentPainFilesByOrganization (state) {
      if (!state.directPaymentPainFiles) {
        return {}
      }
      const map = {}
      state.directPaymentPainFiles.forEach(dppFile => {
        if (!map[dppFile.organization]) {
          map[dppFile.organization] = []
        }
        map[dppFile.organization].push(dppFile)
      })

      return map
    },
    cashPaymentsByCollectionPlan (state) {
      if (!state.cashPayments) {
        return {}
      }
      const map = {}
      Object.values(state.cashPayments).forEach(cashPayment => {
        if (!map[cashPayment.plan]) {
          map[cashPayment.plan] = []
        }
        map[cashPayment.plan].push(cashPayment)
      })

      return map
    }
  },
  mutations: {
    [SET_DIRECT_PAYMENT_PAIN_FILES]: (state, { data }) => {
      state.directPaymentPainFiles = data
    },
    [SET_CASH_PAYMENTS]: (state, { data }) => {
      data.forEach(cashPayment => {
        Vue.set(state.cashPayments, cashPayment.url, cashPayment)
      })
    },
    [ADD_CASH_PAYMENT]: (state, { cashPayment }) => {
      Vue.set(state.cashPayments, cashPayment.url, cashPayment)
    },
    [EDIT_CASH_PAYMENT]: (state, { cashPayment }) => {
      Vue.set(state.cashPayments, cashPayment.url, {
        ...state.cashPayments[cashPayment.url],
        amount: cashPayment.amount,
        created_at: cashPayment.created_at,
        meta: cashPayment.meta,
      })
    },
    [UPDATE_CASH_PAYMENT_STATE]: (state, { cashPayment }) => {
      Vue.set(state.cashPayments, cashPayment.url, {
        ...state.cashPayments[cashPayment.url],
        state: cashPayment.state,
      })
    }
  },
  actions: {
    [FETCH_DIRECT_PAYMENT_PAIN_FILES]: async (context) => {
      return cachedActionWrapper(context, CACHE_DIRECT_PAYMENT_PAIN_FILES, async () => {
        const response = await context.rootGetters.restApi.get('payment/direct_payment_pain_file/')
        await context.commit(SET_DIRECT_PAYMENT_PAIN_FILES, { data: response.data })
      }, async () => {
        await context.commit(SET_DIRECT_PAYMENT_PAIN_FILES, { data: [] })
      })
    },
    [FETCH_CASH_PAYMENTS]: async (context) => {
      return cachedActionWrapper(context, CACHE_CASH_PAYMENTS, async () => {
        const response = await context.rootGetters.restApi.get('cash/cash_payment/')
        await context.commit(SET_CASH_PAYMENTS, { data: response.data })
        delete context.rootState.waitingPromises[CACHE_CASH_PAYMENTS]
      }, async () => {
        await context.commit(SET_CASH_PAYMENTS, { data: [] })
      })
    },
    [CONFIRM_CASH_PAYMENT]: async ({ commit, rootGetters }, { cashPayment }) => {
      commit(INC_LOADING, null, { root: true })
      try {
        const {
          data,
          status,
          error,
        } = await rootGetters.restApi.patch(`${cashPayment.url}confirm/`)

        if (status === 200 && data) {
          commit(UPDATE_CASH_PAYMENT_STATE, { cashPayment: data })
          commit(SET_SNACKBAR_MESSAGE, { message: 'Bargeldeintragung erfolgreich bestätigt' }, { root: true })
          return true
        } else {
          commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${error}` }, { root: true })
          return false
        }
      } catch (error) {
        const errorMessages = error.response.data.join('; ')
        commit(SET_ERROR_MESSAGE, { message: `Fehler in der Übertragung: ${errorMessages}` }, { root: true })
        return false
      } finally {
        commit(DEC_LOADING, null, { root: true })
      }
    }
  }
}
